import { render, staticRenderFns } from "./conversation-list.vue?vue&type=template&id=30472e48&scoped=true&"
import script from "./conversation-list.vue?vue&type=script&lang=js&"
export * from "./conversation-list.vue?vue&type=script&lang=js&"
import style0 from "./conversation-list.vue?vue&type=style&index=0&id=30472e48&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30472e48",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDivider,VExpandTransition,VMenu,VProgressCircular,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30472e48')) {
      api.createRecord('30472e48', component.options)
    } else {
      api.reload('30472e48', component.options)
    }
    module.hot.accept("./conversation-list.vue?vue&type=template&id=30472e48&scoped=true&", function () {
      api.rerender('30472e48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/atendimento/components/conversation-list/conversation-list.vue"
export default component.exports